import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Grid, Typography, Button, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ArrowBackTwoToneIcon from '@mui/icons-material/ArrowBackTwoTone';
import { useSelector } from 'src/store';

const RootWrapper = styled(Box)(() => `flex: 1;`);

function PageHeader() {
  const { t }: { t: any } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { activeEvent } = useSelector((state) => state.events);
  const eventTitle =
    (activeEvent as { evtTitle?: string; evtName?: string } | null)?.evtTitle ||
    activeEvent?.evtName ||
    '';

  return (
    <RootWrapper>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Box>
              <Typography variant="h3" component="h3" gutterBottom>
                {t("Sold by ticket office")}
              </Typography>
              <Typography variant="subtitle2">
                {t('Event')}{' '}
                <b>{eventTitle ? t(eventTitle) : ''}</b>
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item>
          <Button
            sx={{ mt: { xs: 2, sm: 0 } }}
            startIcon={<ArrowBackTwoToneIcon />}
            onClick={() => {
              if (!activeEvent?.id) return;
              navigate(`/dashboard/management/events/statistics/list?eventId=${activeEvent.id}`, {
                state: location.state
              });
            }}
            variant="contained"
          >
            {t("Go back to event statistics")}
          </Button>
        </Grid>
      </Grid>
    </RootWrapper>
  );
}

export default PageHeader;

